import { render, staticRenderFns } from "./VxElasticSuggest.vue?vue&type=template&id=6d438409&scoped=true"
import script from "./VxElasticSuggest.vue?vue&type=script&lang=js"
export * from "./VxElasticSuggest.vue?vue&type=script&lang=js"
import style0 from "./VxElasticSuggest.vue?vue&type=style&index=0&id=6d438409&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d438409",
  null
  
)

export default component.exports